import { keepPreviousData, useMutation, UseMutationResult, useQuery } from '@tanstack/react-query'
import queryKeyFactory from '../queryFactory'
import {
  createDicomTagTagsDeidPost,
  CreateDicomTagTagsDeidPostError,
  CreateDicomTagTagsDeidPostResponse,
  CreateOrUpdateDicomTagSchema,
  deleteDicomTagTagsDeidDicomTagIdDelete,
  DeleteDicomTagTagsDeidDicomTagIdDeleteError,
  DeleteDicomTagTagsDeidDicomTagIdDeleteResponse,
  getPaginatedDicomTagsGet,
  listDicomTagsTagsDeidGet,
  updateDicomTagTagsDeidDicomTagIdPut,
  UpdateDicomTagTagsDeidDicomTagIdPutError,
  UpdateDicomTagTagsDeidDicomTagIdPutResponse,
} from '@common/config/api/client'

export const useGetPaginatedDicom = (params: {
  limit: number
  next_cursor: string | null
  previous_cursor: string | null
  asc_order: boolean
  order_by_field: string
  search: string
}) => {
  return useQuery({
    queryKey: queryKeyFactory.dicomTags(params),
    queryFn: async () => {
      const response = await getPaginatedDicomTagsGet({
        query: params,
      })
      return response.data
    },
    placeholderData: keepPreviousData,
  })
}

export const useCreateDicomTag = (): UseMutationResult<
  CreateDicomTagTagsDeidPostResponse,
  CreateDicomTagTagsDeidPostError,
  { dicomData: CreateOrUpdateDicomTagSchema }
> => {
  return useMutation<
    CreateDicomTagTagsDeidPostResponse,
    CreateDicomTagTagsDeidPostError,
    { dicomData: CreateOrUpdateDicomTagSchema }
  >({
    mutationFn: async ({ dicomData }) => {
      const response = await createDicomTagTagsDeidPost({
        body: dicomData,
        throwOnError: true,
      })
      return response.data
    },
  })
}

export const useDeleteDicomTag = (): UseMutationResult<
  DeleteDicomTagTagsDeidDicomTagIdDeleteResponse,
  DeleteDicomTagTagsDeidDicomTagIdDeleteError,
  { dicom_tag_id: string }
> => {
  return useMutation<
    DeleteDicomTagTagsDeidDicomTagIdDeleteResponse,
    DeleteDicomTagTagsDeidDicomTagIdDeleteError,
    { dicom_tag_id: string }
  >({
    mutationFn: async ({ dicom_tag_id }) => {
      const response = await deleteDicomTagTagsDeidDicomTagIdDelete({
        path: { dicom_tag_id: dicom_tag_id },
        throwOnError: true,
      })
      return response.data
    },
  })
}

export const useUpdateDicomTag = (): UseMutationResult<
  UpdateDicomTagTagsDeidDicomTagIdPutResponse,
  UpdateDicomTagTagsDeidDicomTagIdPutError,
  { dicom_data: CreateOrUpdateDicomTagSchema; dicom_tag_id: string }
> => {
  return useMutation<
    UpdateDicomTagTagsDeidDicomTagIdPutResponse,
    UpdateDicomTagTagsDeidDicomTagIdPutError,
    { dicom_data: CreateOrUpdateDicomTagSchema; dicom_tag_id: string }
  >({
    mutationFn: async ({ dicom_data, dicom_tag_id }) => {
      const response = await updateDicomTagTagsDeidDicomTagIdPut({
        body: dicom_data,
        path: { dicom_tag_id: dicom_tag_id },
        throwOnError: true,
      })
      return response.data
    },
  })
}

export const useGetAllDicomTagDeid = () => {
  return useQuery({
    queryKey: ['dicom tags deid'],
    queryFn: async () => {
      const response = await listDicomTagsTagsDeidGet()
      return response.data
    },
  })
}
